import React from 'react';
import PropTypes from 'prop-types';
import { cloneDeep } from 'lodash';
import { withTranslation } from 'react-i18next';
import TitleFrom from '../../../../components/common/TitleFrom';
import { GenericInput, PasswordField } from '../../../../components/common';
import dataField from '../../constant';

class JsonWebTokenAttributeForm extends React.PureComponent {
  state = { tenantData: [{}], isReadOnly: true };

  componentDidMount() {
    const { data } = this.props;
    this.setState({ tenantData: data });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.data) {
      this.setState({ tenantData: nextProps.data });
    }
  }

  onChange = ({ value, name }) => {
    try {
      const { onHandleChange, index } = this.props;
      const { tenantData } = this.state;
      const newData = cloneDeep(tenantData);
      newData[0][name] = value;
      onHandleChange({ value, name, index, indexAttr: 0, fieldName: 'jwtAttributes', isNotIndex: true });
      this.setState({ tenantData: newData });
    } catch (error) {
      console.log(error);
    }
  };

  onFocusPasswordField = () => {
    this.setState({ isReadOnly: false });
  };

  render() {
    const { tenantData, isReadOnly } = this.state;
    const dataJsonAttr = tenantData[0];
    const { modeModifyPaymentGatewayMerchant, isRequireField, t } = this.props;
    return (
      <div className="col-md-12 sub-from">
        <div className="d-block d-md-flex">
          <div className="d-block d-md-flex clearfix sm-mt-20 ">
            <TitleFrom title={t('label.jsonWebTokenAttributes')} />
          </div>
        </div>
        <div className="group-flex">
          {dataField.fieldJsonWebTokenForm.map(item => {
            if (item.isOptionType)
              return (
                <PasswordField
                  key={item.name}
                  label={item.label}
                  value={dataJsonAttr ? dataJsonAttr[item.name] : null}
                  disabled={modeModifyPaymentGatewayMerchant === 1}
                  onChange={this.onChange}
                  required={isRequireField || item.required}
                  name={item.name}
                  wrapperClass="col-md-6"
                  readOnly={isReadOnly}
                  onFocus={this.onFocusPasswordField}
                />
              );
            return (
              <GenericInput
                key={item.name}
                label={item.label}
                value={dataJsonAttr ? dataJsonAttr[item.name] : ''}
                type="text"
                disabled={modeModifyPaymentGatewayMerchant === 1}
                onChange={this.onChange}
                required={isRequireField || item.required}
                name={item.name}
                wrapperClass="col-md-6"
              />
            );
          })}
        </div>
      </div>
    );
  }
}

JsonWebTokenAttributeForm.propTypes = {
  data: PropTypes.arrayOf(PropTypes.any),
  onHandleChange: PropTypes.func,
  index: PropTypes.number.isRequired,
  modeModifyPaymentGatewayMerchant: PropTypes.number,
  isRequireField: PropTypes.bool,
};

JsonWebTokenAttributeForm.defaultProps = {
  data: [],
  onHandleChange: () => {},
  modeModifyPaymentGatewayMerchant: 2,
  isRequireField: false,
};

export default withTranslation('common')(JsonWebTokenAttributeForm);
